import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../auth/auth.service";
import {AccountService} from "../account.service";
import {NotificationBarService} from "../../core/notify/notification.service";
import {NotificationType} from "../../core/notify";
import {GlobalValidator} from "../../shared/validators/global-validator";
import {GlobalService} from "../../global/global.service";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  form : FormGroup ;
  isLoading: boolean;
  designations : any [] = [];

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private accountService: AccountService,
              private notifier: NotificationBarService,
              private global: GlobalService) {

    this.designations = this.global.getAllDesignations();
  }

  userProfile = {
    name:'',
    email:'',
    role:'',

  };

  formErrors = {
    'name':''
  };
  userAccount = {
    name: '',
    id:''
  };

  ngOnInit() {
    this.userProfile = this.authService.getUserProfile();
    this.authService.getProfileSubject()
      .subscribe((response)=>
        {this.userProfile = response;
          this.setFormValue(this.userProfile);
        }
      );
    this.userAccount = this.authService.getCurrentAccount();
    this.buildForm();
    this.userProfile ? this.setFormValue(this.userProfile):'';

  }

  setFormValue(profile){
    if(!profile)
      return;
     this.form.controls['name'].setValue(profile.name);
     this.form.controls['email'].setValue(profile.email);
     this.form.controls['role'].setValue(profile.account[0].userRole);
     this.form.controls['organizationRole'].setValue(profile.organizationRole);
  }
  buildForm(){
    this.form = this.fb.group({
      'name': ['', [GlobalValidator.consecutiveSpace,
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(50)
      ]],
      'email': ['', []],
      'role': ['', []],
      'organizationRole': ['', []]
      }
    );

    this.form.valueChanges
      .subscribe(data => this.onValueChanged(data));
    this.onValueChanged();
  }

  update(){
    this.onValueChanged();
    if(this.form.valid){
      this.isLoading = true;
      this.accountService.updateProfile({name: this.form.controls['name'].value,
        organizationRole:this.form.controls['organizationRole'].value})
        .subscribe((response)=>
          {
            this.isLoading = false;
            this.notifier.create({message: response.status.message, type: NotificationType.Success});
            this.authService.setUserProfileAfterUpdate(response.data);
          },(error)=>{this.isLoading = false; this.notifier.create({message:error, type:NotificationType.Error})}
        )
    }

  }

  onValueChanged(data?: any){
    if (!this.form) { return; }
    const form = this.form;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && (control.dirty && !control.valid)) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
        }
      }
    }
}
validationMessages = {
    'name':{
      'required':'PROFILE.NAME_VALIDATION.REQUIRED',
      'consecutiveSpace':'CMN_VALIDATIONS.CONSECUTIVE_SPACE',
      'minlength':'CMN_VALIDATIONS.MIN_LENGTH_TWO',
      'maxlength':'PROFILE.NAME_VALIDATION.MAX_LENGTH'
    }
}

}



// WEBPACK FOOTER //
// ./src/app/accounts/profile/profile.component.ts